module.exports = __webpack_public_path__ + "static/media/property.5298f613.svg";